export const STAGE = 'prod'.toLowerCase();

export enum STAGES {
  test = 'test',
  development = 'development',
  alpha = 'alpha',
  beta = 'beta',
  prod = 'prod',
}

export const ATOZ_ROOT_CLASS_NAME = 'app-root';
export const PREFERRED_LANGUAGE_DOM_ATTRIBUTE = 'data-locale';
export const REQUIRED_DOM_ATTRIBUTES = [
  'data-employee-id',
  'data-country-code',
  'data-is-app',
  'data-is-external-network',
  PREFERRED_LANGUAGE_DOM_ATTRIBUTE,
  'data-popstar-features',
];

export const FAB_RENDERING_OPERATION_NAME = 'FabRendering';
